import { z } from 'zod/v4-mini'

export const searchParamsProjectIds = z.object({
    projectIds: z._default(z.array(z.string()), []),
})

export const searchParamsProjectIdsDefaultValue: z.infer<
    typeof searchParamsProjectIds
> = {
    projectIds: searchParamsProjectIds.shape.projectIds.def.defaultValue,
}
